import { ListOfEvents } from "../ListOfEvents/ListOfEvents";
import awardsInfo from "../../api/awards.json";

export const Awards = () => {
	const awardsData = awardsInfo.map((award) => ({
		id: award.awardId,
		year: award.awardYear,
		info: award.awardInfo,
		infoSecond: award.awardInfoSecond,
	}));
	return (
		<section className="container awardsAfilPage">
			<div className="awards">
				{/*<h1 className="awards__component__title">AWARDS</h1>*/}

				<ListOfEvents events={awardsData} />
			</div>
			<div className="affiliations">
				<h1 className="affiliations__component__title">AFFILIATIONS</h1>
				<div className="affiliations__component">
					<div className="affiliations__component-wrap">
						<p>
							Senior Fellow, Institute for Public Administration,
							Joseph R. Biden, Jr. School of Public Policy &
							Administration
						</p>
						<p>
							Faculty Fellow, Center for Organization Research and
							Design, Arizona State University, Phoenix, AZ.
						</p>
					</div>
				</div>
			</div>
		</section>
	);
};
